import { useMutation } from '@apollo/client'
import { ExportSection } from 'api/graphQL/mutations/export.mutations'
import { useActionBarActions } from 'components/WorkspaceEditor/ActionBarStore'
import useGlobalSnackbar from 'shared/utils/useGlobalSnackbar'

export const useExportSectionMutation = () => {
    const { setIsExportLoading, setExportUrl } = useActionBarActions()
    const { showGlobalSnackbar } = useGlobalSnackbar()

    const [exportSection] = useMutation(ExportSection, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            const errorMessage = data?.exportProjectProductFamily?.errorMessage
            const fileType = data?.exportProjectProductFamily?.fileType
            if (errorMessage) {
                showGlobalSnackbar({
                    variables: {
                        message: errorMessage,
                        variant: 'error',
                        id: 'ExportFailed',
                    },
                })
                setIsExportLoading(fileType, false)
                return
            }
            setExportUrl(
                fileType,
                data?.exportProjectProductFamily?.downloadURL
            )
            setTimeout(() => {
                setIsExportLoading(fileType, false)
            }, 1000)
        },
        onError: (err) => {
            showGlobalSnackbar({
                variables: {
                    message: err.message,
                    variant: 'error',
                    id: 'ExportFailed',
                },
            })
        },
    })
    return { exportSection }
}
